module.exports = __webpack_public_path__ + "static/media/grandpa.619351bb.jpg";